import { render, staticRenderFns } from "./FormulateCurrency.vue?vue&type=template&id=628fd61f&"
import script from "./FormulateCurrency.vue?vue&type=script&lang=js&"
export * from "./FormulateCurrency.vue?vue&type=script&lang=js&"
import style0 from "./FormulateCurrency.vue?vue&type=style&index=0&id=628fd61f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports